
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import addDialog from '../components/add-dialog.vue';
import FormInstance, { ElMessage, ElForm } from 'element-plus';
import { HANDLE_SERVICE_TYPE_LIST, FIRST_PEOPLE_ENUM } from '@/constant/project-service/index';
import {
  IManageBatchCreatePMReq,
  IManageQueryProjectByLikeRes,
  IFirstMenuItem,
  IFirstTableList,
  ISecondCallBackItem,
  serviceBasicInfoRes,
  ISecondMenuOptions,
} from '@/api/project-service/type.d';
import {
  manageQueryProjectByLike,
  manageSelectAllServiceBasicInfo,
  manageBatchCreatePM,
} from '@/api/project-service/index';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { useFuzzy } from '@/hooks/use-fuzzy';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';

export default defineComponent({
  components: { addDialog },
  setup() {
    const id = ref<number>(0);
    const selected = ref<any[]>([]);
    const firstTableList = ref<IFirstTableList[]>([]);
    const firstMenuList = ref<IFirstMenuItem[]>([]);
    const firstMenuOptions = ref<string[]>([]);
    const servicesList = ref<serviceBasicInfoRes>({} as serviceBasicInfoRes);
    const addSecondsVisible = ref<boolean>(false);
    const isAllowCreate = ref<boolean>(true);
    const IsDisabled = ref<boolean>(true);
    const projectTip = ref<boolean>(false);
    const projectExitTip = ref<boolean>(false);
    const ruleFormRef = ref<typeof FormInstance>();
    const firstRuleFormRefList = ref<typeof ElForm[]>([]);
    const formData = ref<IManageBatchCreatePMReq>(
      {} as IManageBatchCreatePMReq,
    );
    const projectNameList = ref<IManageQueryProjectByLikeRes>(
      {} as IManageQueryProjectByLikeRes,
    );
    const options = ref<ISecondMenuOptions>({} as ISecondMenuOptions);
    const router = useRouter();
    const handleAdd = () => {
      id.value += 1;
      return {
        id: id.value,
        isShowTip: false,
        firstList: {} as IFirstMenuItem,
      };
    };
    // 模糊输入负责人名字
    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(_param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });
    const handleShowTip = (key: string, row: any) => {
      if (key === '') {
        row.isShowTip = false;
        return;
      }
      if (!firstMenuOptions.value.includes(key)) {
        row.isShowTip = true;
      } else {
        row.isShowTip = false;
      }
    };
    const handleSelectRemoteItem = (userInfo: UserItem, row:IFirstMenuItem, key: FIRST_PEOPLE_ENUM) => {
      switch (key) {
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST:
          row.headOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.headOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND:
          row.secondHeadOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.secondHeadOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_FIRST:
          row.headOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.headOfTest = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_SECOND:
          row.secondHeadOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.secondHeadOfTest = '';
          }
          break;
        default: break;
      }
    };
    // 删除一级菜单
    const handleDeleteFirstMenu = () => {
      if (selected.value.length) {
        if (selected.value.length === firstTableList.value.length) {
          firstTableList.value = [];
          return;
        }
        selected.value.forEach((item) => {
          const index = firstTableList.value.indexOf(item);
          firstTableList.value.splice(index, 1);
        });
        selected.value = [];
      }
    };
    const handleBack = () => {
      router.replace({
        name: 'ProjectServiceManageProjectServiceList',
      });
    };
    const handleSubmit = async () => {
      const checkPass = ref<number>(0);
      firstRuleFormRefList.value.forEach(async (formRef) => {
        await formRef?.validate((vialed: boolean) => {
          if (vialed) {
            checkPass.value += 1;
          }
        });
      });
      await (ruleFormRef.value as any).validate();
      const menuList = firstTableList.value.map((item) => {
        if (item.firstList.firstLevelMenu) {
          return item.firstList.firstLevelMenu;
        }
        return item.firstList;
      });
      console.log(menuList);
      if ([...new Set(menuList)].length !== menuList.length) {
        ElMessage.error('一级菜单新增存在重复，请检查!');
        return;
      }
      if (checkPass.value === firstRuleFormRefList.value.length) {
        firstMenuList.value = [];
        firstTableList.value.forEach((item) => {
          firstMenuList.value.push(item.firstList);
        });
        formData.value.firstLevelMenuInfos = firstMenuList.value;
        formData.value.domainName = formData.value.domainName || '-';
        try {
          await manageBatchCreatePM(formData.value);
          formData.value = {} as IManageBatchCreatePMReq;
          options.value = {} as ISecondMenuOptions;
          handleDeleteFirstMenu();
          ElMessage.success('操作成功');
          handleBack();
        } catch (error) {
          console.log(error);
        }
      }
    };
    // 处理选中服务，回显对应后端负责人
    const handleSelectServiceItem = (val: any, row: IFirstMenuItem) => {
      const res = servicesList.value.filter((item) => {
        return item.serviceName === val;
      });
      console.log(res[0], 'res');
      row.firstHeadBackend = `${res[0]?.firstHeadOfBackend}(${res[0]?.firstHeadOfBackendCode})`;
      row.secondHeadBackend = `${res[0]?.secondHeadOfBackend}(${res[0]?.secondHeadOfBackendCode})`;
      if (res[0]?.firstHeadOfBackend === '') {
        row.firstHeadBackend = '';
      }
      if (res[0]?.secondHeadOfBackend === '') {
        row.secondHeadBackend = '';
      }
    };
    // 选中项目名称，处理对应域名及一级菜单
    const handleSelectItem = (val: string) => {
      console.log(val, 'val');
      if (formData.value.projectName === '') {
        projectTip.value = false;
      }
      if (!projectNameList.value.length) {
        if (formData.value.projectName === '') {
          return;
        }
        projectTip.value = true;
        return;
      }
      if (projectNameList.value.length) {
        const addProjectList = projectNameList.value.map(item => item.projectName);
        if (formData.value.projectName !== '' && !addProjectList.includes(formData.value.projectName)) {
          projectTip.value = true;
        }
      }
      projectNameList.value.forEach((item) => {
        if (item.projectName === val) {
          firstMenuOptions.value = item.firstLevelMenus;
          formData.value.domainName = item.domainName;
          projectTip.value = false;
          IsDisabled.value = true;
        }
      });
    };
    // 查询项目名称
    const handleRemoteMethod = async (query: string) => {
      console.log(query, 'query ');
      const projectNames = ref<string[]>([]);
      if (!query) {
        projectNameList.value = [];
        return;
      }
      if (formData.value.projectName === query) {
        handleSelectItem(query);
      } else {
        formData.value.domainName = '';
      }
      const { data } = await manageQueryProjectByLike(query);
      if (!data) {
        projectNameList.value = [];
        isAllowCreate.value = true;
        IsDisabled.value = false;
        return;
      }
      projectNameList.value = data.filter((item) => {
        const { projectName } = item;
        projectNames.value.push(projectName);
        return item.projectName.toLowerCase().includes(query.toLowerCase());
      });
      if (!projectNameList.value.length) {
        formData.value.projectName = query;
      }
      projectNameList.value = [...new Set(projectNameList.value)];
      if (projectNames.value.includes(query)) {
        isAllowCreate.value = false;
        IsDisabled.value = true;
      } else {
        isAllowCreate.value = true;
        IsDisabled.value = false;
        projectTip.value = true;
      }
    };
    const handleSelectionChange = (val: any[]) => {
      selected.value = val;
    };
    // 添加一级菜单
    const handleAddFirstMenu = async () => {
      await (ruleFormRef.value as any).validate();
      const add = handleAdd();
      firstTableList.value.push(add);
    };
    // 处理二级菜单回显
    const handleSecondsMenu = async (firstOptions: any, index: number) => {
      // 表单验证
      if (!firstTableList.value[index].firstList.firstLevelMenu) {
        const formRef = firstRuleFormRefList.value[index];
        await formRef?.validate();
      }
      options.value.projectName = formData.value.projectName;
      options.value.firstLevelMenu = firstOptions.firstLevelMenu;
      options.value.firstHeadBackend = firstOptions.firstHeadBackend;
      options.value.secondHeadBackend = firstOptions.secondHeadBackend;
      options.value.headOfDevelopment = firstOptions.headOfDevelopment;
      options.value.secondHeadOfDevelopment = firstOptions.secondHeadOfDevelopment;
      options.value.headOfTest = firstOptions.headOfTest;
      options.value.secondHeadOfTest = firstOptions.secondHeadOfTest;
      options.value.serviceName = firstOptions.serviceName;
      options.value.serviceType = firstOptions.serviceType;
      options.value.secondLevelMenuInfos = firstOptions.secondLevelMenuInfos;
      addSecondsVisible.value = true;
    };

    const handleClear = () => {
      formData.value.domainName = '';
    };
    // 查询后端服务
    const handleSearchService = async () => {
      const { data } = await manageSelectAllServiceBasicInfo();
      if (!data) {
        servicesList.value = [];
        return;
      }
      servicesList.value = data;
    };
    // 处理展开行输入自动收起
    const handleRowKey = (row: any) => {
      return row.id;
    };
    // 处理二级菜单回调
    const handleCallBack = (data: ISecondCallBackItem) => {
      firstTableList.value.forEach((item, index, arr) => {
        if (item.firstList.firstLevelMenu === data.firstLevelMenu
        && data.projectName === formData.value.projectName) {
          firstMenuList.value.push(item.firstList);
          arr[index].firstList.secondLevelMenuInfos = data.secondList;
          if (index === 0) {
            const { firstLevelMenu } = arr[index].firstList;
            arr[index].firstList.firstLevelMenu = firstLevelMenu;
          }
        }
      });
      firstMenuList.value = [...new Set(firstMenuList.value)];
    };

    const rules = ref({
      projectName: [{ required: true, message: '请选择或新增项目', trigger: 'change' }],
    });
    const handleCustomerCheck = (_rule: any, value: any, callback: any) => {
      if (value !== '' && firstMenuOptions.value.includes(value)) {
        const isPass = firstTableList.value.every((item) => {
          if (item.firstList.firstLevelMenu === value) {
            return item.firstList.secondLevelMenuInfos?.length;
          }
          return item.firstList.firstLevelMenu;
        });
        if (!isPass) {
          callback(new Error('非新建的一级菜单必须包含二级菜单'));
        }
      }
      callback();
    };
    const firstMenuRules = ref({
      firstLevelMenu: [
        { required: true, message: '请输入一级菜单', trigger: 'change' },
        { required: true, validator: handleCustomerCheck, trigger: 'change' },

      ],
    });
    return {
      formData,
      selected,
      ruleFormRef,
      firstRuleFormRefList,
      handleBack,
      firstMenuRules,
      handleCallBack,
      firstTableList,
      firstMenuOptions,
      handleSubmit,
      options,
      handleShowTip,
      projectTip,
      projectExitTip,
      rules,
      HANDLE_SERVICE_TYPE_LIST,
      FIRST_PEOPLE_ENUM,
      addSecondsVisible,
      isAllowCreate,
      handleRowKey,
      projectNameList,
      servicesList,
      handleSelectItem,
      handleSearchService,
      handleSelectServiceItem,
      handleSecondsMenu,
      handleRemoteMethod,
      handleSelectionChange,
      handleAddFirstMenu,
      handleDeleteFirstMenu,
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
      handleSelectRemoteItem,
      IsDisabled,
      handleClear,
    };
  },
});
